import Vue from "vue";
import currency from "v-currency-field";

Vue.use(currency)

export default currency;
